

// **********************************
// *********** FR *******************
// **********************************
import common_fr from "translations/fr/common.json"
import bike_fr from "translations/fr/bike.json"
import partner_fr from "translations/fr/partner.json"
import bikeCollectionImport_fr from "translations/fr/bikeCollectionImport.json"
import form_fr from "translations/fr/form.json"
import contact_fr from "translations/fr/contact.json"
import auth_fr from "translations/fr/auth.json"
import team_fr from "translations/fr/team.json"
import user_fr from "translations/fr/user.json"
import api_fr from "translations/fr/api.json"

// **********************************
// *********** EN *******************
// **********************************
import common_en from "translations/en/common.json"
import bike_en from "translations/en/bike.json"
import partner_en from "translations/en/partner.json"
import bikeCollectionImport_en from "translations/en/bikeCollectionImport.json"
import form_en from "translations/en/form.json"
import contact_en from "translations/en/contact.json"
import auth_en from "translations/en/auth.json"
import team_en from "translations/en/team.json"
import user_en from "translations/en/user.json"
import api_en from "translations/en/api.json"

// **********************************
// *********** DE *******************
// **********************************
import common_de from "translations/de/common.json"
import bike_de from "translations/de/bike.json"
import partner_de from "translations/de/partner.json"
import bikeCollectionImport_de from "translations/de/bikeCollectionImport.json"
import form_de from "translations/de/form.json"
import contact_de from "translations/de/contact.json"
import auth_de from "translations/de/auth.json"
import team_de from "translations/de/team.json"
import user_de from "translations/de/user.json"
import api_de from "translations/de/api.json"

// **********************************
// *********** ES *******************
// **********************************
import common_es from "translations/es/common.json"
import bike_es from "translations/es/bike.json"
import partner_es from "translations/es/partner.json"
import bikeCollectionImport_es from "translations/es/bikeCollectionImport.json"
import form_es from "translations/es/form.json"
import contact_es from "translations/es/contact.json"
import auth_es from "translations/es/auth.json"
import team_es from "translations/es/team.json"
import user_es from "translations/es/user.json"
import api_es from "translations/es/api.json"

export const resources = {
  fr: {
    translation: common_fr,
    bike: bike_fr,
    partner: partner_fr,
    bikeCollectionImport: bikeCollectionImport_fr,
    form: form_fr,
    contact: contact_fr,
    auth: auth_fr,
    team: team_fr,
    user: user_fr,
    api: api_fr
  },
  gb: {
    translation: common_en,
    bike: bike_en,
    partner: partner_en,
    bikeCollectionImport: bikeCollectionImport_en,
    form: form_en,
    contact: contact_en,
    auth: auth_en,
    team: team_en,
    user: user_en,
    api: api_en
  },
  de: {
    translation: common_de,
    bike: bike_de,
    partner: partner_de,
    bikeCollectionImport: bikeCollectionImport_de,
    form: form_de,
    contact: contact_de,
    auth: auth_de,
    team: team_de,
    user: user_de,
    api: api_de
  },
  es: {
    translation: common_es,
    bike: bike_es,
    partner: partner_es,
    bikeCollectionImport: bikeCollectionImport_es,
    form: form_es,
    contact: contact_es,
    auth: auth_es,
    team: team_es,
    user: user_es,
    api: api_es
  }
}